import React from 'react';
import { Card } from 'react-bootstrap';
import { FiTool } from 'react-icons/fi';

const DepartmentPlaceholderPage = ({ departmentName = '' }) => {
  return (
    <Card className="border-0 shadow-sm card-accent-top">
      <Card.Body>
        <div className="empty-state">
          <div className="icon-chip icon-chip-lg icon-chip-secondary">
            <FiTool />
          </div>
          <div className="empty-state-title">Dashboard coming soon</div>
          <p className="empty-state-subtitle">
            The dashboard layout for {departmentName || 'this department'} isn&apos;t configured yet. It will be added once department-specific data is available.
          </p>
        </div>
      </Card.Body>
    </Card>
  );
};

export default DepartmentPlaceholderPage;
